import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfigurationService, CoursesService } from '@draeger-academy/common';
import { User } from 'models';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'da-person-card',
    templateUrl: './person-card.component.html',
    styleUrls: ['./person-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PersonCardComponent implements OnInit {
    @Input() isParticipant = false;
    @Input() isBillingContact = false;
    @Output()
    nextStep: EventEmitter<string> = new EventEmitter<string>();
    @Input() person: User = new User([]);
    @Input() orderNumber = '';
    private _currentData = null;
    public translatedSalutation: string;
    public translatedCountry: string;
    public salutationData: any;
    public countriesData: any;

    constructor(private _configurationService: ConfigurationService, private _courseService: CoursesService) {}
    private _$showPersonalData: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showPersonalData$(): Observable<boolean> {
        return this._$showPersonalData.asObservable();
    }

    private _$person: BehaviorSubject<any> = new BehaviorSubject(null);
    public get person$(): Observable<any> {
        return this._$person.asObservable();
    }
    private _$countryName: BehaviorSubject<string> = new BehaviorSubject('');
    public get countryName$(): Observable<string> {
        return this._$countryName.asObservable();
    }
    private _$hasRegions: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get hasRegions$(): Observable<boolean> {
        return this._$hasRegions.asObservable();
    }

    ngOnInit() {
        this.createPerson();
        this._courseService.languageSelected.subscribe((language) => {
            this.createPerson();
        });
    }

    private translateSalutationsAndCountries(person) {
        this.salutationData = this._configurationService.$allSalutationsByLanguage.getValue();
        this.countriesData = this._configurationService.$allCountriesByLanguage.getValue();
        const salutation = this.salutationData.filter((item) => item.key === person.salutation);
        const country = this.countriesData.filter((item) => item.key === person.country);

        if (salutation && salutation[0]) {
            this.translatedSalutation = salutation[0].value;
        } else {
            this.translatedSalutation = this.person.salutation.name;
        }
        if (country && salutation[0]) {
            this.translatedCountry = country[0].value;
        } else {
            this.translatedCountry = this.person.country.name;
        }
    }

    private createPerson() {
        if (this._configurationService.hasFeature('PersonalData')) {
            this._$showPersonalData.next(true);
        }

        const userObj = {
            address: this.person.address,
            houseNumber: this.person.houseNumber,
            city: this.person.city,
            company: this.person.company && this.person.company.name ? this.person.company.name : this.person.company,
            country: this.person.country && this.person.country.name ? this.person.country.name : this.person.country,
            regionKey: this.person.regionKey && this.person.regionKey ? this.person.regionKey : this.person.regionKey,
            department: this.person.department,
            email: this.person.email,
            firstName: this.person.firstName,
            lastName: this.person.lastName,
            phone: this.person.phone,
            salutation:
                this.person.salutation && !(typeof this.person.salutation === 'string')
                    ? this.person.salutation.name
                    : this.person.salutation,
            subscribe: this.person.subscribe,
            title: this.person.title,
            zipCode: this.person.zipCode,
            POnumber: this.person.POnumber,
            note: this.person.note
        };

        this._$person.next(userObj);
        this.translateSalutationsAndCountries(this._$person.getValue());
    }

    goToBookingPerson() {
        this.nextStep.emit('1');
    }

    goToBookingParticipants() {
        this.nextStep.emit('2');
    }
}
